import { useEffect, useState } from "react";
import { ReactComponent as GoogleIcon } from "assets/images/svgs/google-icon.svg";
import { ReactComponent as FacebookIcon } from "assets/images/svgs/facebook-icon.svg";
import { ReactComponent as AppleIcon } from "assets/images/svgs/apple-icon.svg";
import { ReactComponent as UserIcon } from "assets/images/svgs/user-icon.svg";

import logo from "assets/images/others/host-side-images/logo.png";
import {  useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import TermsAndCondition from "components/drawers/host-side/TermsAndCondtion";
import PrivacyPolicy from "components/drawers/host-side/PrivacyPolicy";
import useOutsideClick from "hooks/click-outside";
import { signInWithPopup, auth, googleProvider, appleProvider } from "../../../firebase";
import { LoginByGoogleDTO } from "utils/helpers/models/auth/login-by-google.dto";
import { LoginByAppleDTO } from "utils/helpers/models/auth/login-by-apple.dto";
import useUtils from "hooks/useUtils";
import useAuth from "../useHooks";
import { ROLES } from "utils/helpers/enums/roles.enum";

const SignUp = () => {
  const [termsDrawerOpen, setTermsDrawerOpen] = useState<boolean>(false);
  const [policydrawerOpen, setPolicyDrawerOpen] = useState<boolean>(false);
  const [privacyPolicyContent, setPrivacyPolicyContent] = useState<[]>([]);
  const [privacyPolicy, setPrivacyPolicy] = useState<[]>([]);
  const { getQueryParams } = useUtils();
  const { loginByGoogle, loginByApple, getPrivacyPolicy } = useAuth();
  const query = getQueryParams();
    const [googleLoginForm, setGoogleLoginForm] = useState<LoginByGoogleDTO>(
      new LoginByGoogleDTO(query)
    );
    const [appleLoginForm, setAppleLoginForm] = useState<LoginByAppleDTO>(
      new LoginByAppleDTO(query)
    );
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const { _tokenResponse = null } = (result as any) || {};
      if (_tokenResponse) {
        const { oauthAccessToken: accessToken } = _tokenResponse as any;
        if (accessToken) {
          googleLoginForm.accessToken = accessToken;
          setGoogleLoginForm(googleLoginForm);
          loginByGoogle(googleLoginForm);
        }
      }
    } catch (error) {
      console.log("Error in google login", error);
    }
  };
  
  const handleAppleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, appleProvider);
      const user = result.user;
      
      // Extract user information from Apple sign-in
      const displayName = user.displayName || '';
      const nameParts = displayName.split(' ');
      const firstName = nameParts[0] || '';
      const lastName = nameParts.slice(1).join(' ') || '';
      
      const appleData = new LoginByAppleDTO({
        firstName: firstName,
        lastName: lastName,
        email: user.email || '',
        uid: user.uid,
        role: appleLoginForm.role,
        profileType: appleLoginForm.profileType
      });
      
      setAppleLoginForm(appleData);
      loginByApple(appleData);
    } catch (error) {
      console.log("Error in apple login", error);
    }
  };

  const toggleTermsDrawer = () => {
    setTermsDrawerOpen(!termsDrawerOpen);
  };
  const togglePolicyDrawer = () => {
    setPolicyDrawerOpen(!policydrawerOpen);
  };

  const roleHeadingMap: Record<string, string> = {
    ATTENDEE: "Parent/Legal Guardian Attestation",
    HOST: "Host User Agreement",
    AMBASSADOR: "User Agreement",
  };

  useEffect(() => {
    if (!query?.role) return;
    const heading = roleHeadingMap[query.role];
    if (heading) {
      getPrivacyPolicy({ heading }, setPrivacyPolicyContent);
    }
    getPrivacyPolicy({ heading: "Privacy policy" }, setPrivacyPolicy);
  }, [query?.role]);

  return (
    <div className="w-full h-screen overflow-y-auto flex flex-col p-4 sm:p-6 lg:px-8 xl:px-10 lg:py-6">
      <div className="flex justify-center my-6">
        <img src={logo} alt="logo" className="h-20" />
      </div>
      <div className="flex-1 flex  justify-center">
        <div className="w-full">
          <h1 className="text-3xl font-medium text-blackie mb-4 capitalize">
            Sign Up as {googleLoginForm.role.toLowerCase()}
          </h1>

          <div className="flex flex-col gap-4 w-full text-blackie">
            <button
              onClick={handleGoogleLogin}
              className="w-full lg:h-[64px] flex items-center p-3  gap-2 justify-center border border-borderColor rounded-full px-6 text-blackie text-lg hover:bg-fade hover:text-blueText transition-all duration-300 ease-in-out"
            >
              <GoogleIcon className="w-6 h-6" />
              <span className="text-blackie">Continue with Google</span>
            </button>
            {/* <button
              onClick={() => setShowLaunchingSoonModal(true)}
              className="w-full p-3 lg:h-[64px] flex items-center  gap-2 justify-center border border-borderColor  rounded-full px-6 text-blackie text-lg hover:bg-fade hover:text-yellowText transition-all duration-300 ease-in-out"
            >
              <FacebookIcon className="w-6 h-6" />
              <span className="text-blackie">Continue with Facebook</span>
            </button> */}
            <button
              onClick={handleAppleLogin}
              className="w-full p-3 lg:h-[64px] flex items-center  gap-2 justify-center border border-borderColor  rounded-full px-6 text-blackie text-lg hover:bg-fade hover:text-purpleText transition-all duration-300 ease-in-out"
            >
              <AppleIcon className="w-6 h-6" />
              <span className="text-blackie">Continue with Apple ID</span>
            </button>
            {googleLoginForm.role === ROLES.HOST && (
              <button
                onClick={() => {
                  navigate(siteRoutes.registerInfo);
                }}
                className="w-full p-3 lg:h-[64px] flex items-center gap-2 justify-center border border-borderColor hover:border rounded-full px-6 text-blackie text-lg hover:bg-fade hover:text-purpleText transition-all duration-300 ease-in-out"
              >
                <UserIcon className="w-6 h-6" />
                <span className="text-blackie">Continue with Email</span>
              </button>
            )}
            <div className="text-center mt-4">
              <p className="text-blackie text-base">
                Already have an Account?
                <span
                  onClick={() => {
                    navigate(siteRoutes.login);
                  }}
                  className="text-yellowText cursor-pointer ml-[3.5px]"
                >
                  Sign in
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center">
        <p className="text-blackie text-base">
          By continuing, you agree to Learn Local’s
          <span
            onClick={toggleTermsDrawer}
            className="text-yellowText cursor-pointer ml-[3.5px]"
          >
            Terms of Service.
          </span>
        </p>
        <p className="text-blackie text-base">
          We will manage information aboutyou as described in our
          <span
            onClick={togglePolicyDrawer}
            className="text-yellowText cursor-pointer ml-[3.5px]"
          >
            Privacy Policy.
          </span>
        </p>
      </div>
      <TermsAndCondition
        isOpen={termsDrawerOpen}
        onClose={toggleTermsDrawer}
        content={privacyPolicyContent}
      />
      <PrivacyPolicy
        isOpen={policydrawerOpen}
        onClose={togglePolicyDrawer}
        content={privacyPolicy}
      />
    </div>
  );
};

export default SignUp;
